import { useRef, useState } from 'react';

import {
  Grid,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  useTheme,
} from '@mui/material';

import api from '../../services/api';
import toastError from '../../toasts/toastError';
import { getStyled } from './styles';

const ButtonModal = ({ modalOpen, onClose, ticketId }) => {
  const theme = useTheme();
  const classes = getStyled(theme);
  const [selectedOption, setSelectedOption] = useState('');
  const [inputList, setInputList] = useState([{ option: '' }]);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [buttonText, setButtonText] = useState('');
  const [copyText, setCopyText] = useState('');
  const [sendCALL, setSendCall] = useState('');
  const [sendURL, setSendURL] = useState('');
  const [imageBase64, setImageBase64] = useState('');
  const [sendKey, setsendKey] = useState('');
  const [sendkey_type, setsendkey_type] = useState('');
  const [sendvalue, setsendvalue] = useState('');
  const [sendmerchant_name, setsendmerchant_name] = useState('');
  const isMounted = useRef(true);

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleAddOption = () => {
    setInputList([...inputList, { option: '' }]);
  };

  const handleRemoveOption = (index) => {
    setInputList((prev) => prev.filter((_, i) => i !== index));
  };

  const handleInputChange = (index, event) => {
    const updatedInputs = [...inputList];
    updatedInputs[index].option = event.target.value;
    setInputList(updatedInputs);
  };

  const handleUploadListMessage = async (
    title,
    description,
    inputList,
    ticketId,
  ) => {
    if (!ticketId || isNaN(ticketId)) {
      console.error('ID do Ticket inválido:', ticketId);
      toastError('ID do Ticket inválido.');
      return;
    }

    try {
      const sections = [
        {
          title: title || 'Opções',
          rows: inputList.map((input, index) => ({
            title: input.option,
            rowId: (index + 1).toString(),
          })),
        },
      ];

      const listMessage = {
        title: `${title}\n`,
        text: `${description}\n`,
        buttonText: 'Clique aqui',
        sections: sections,
      };
      if (isMounted.current) {
        await api.post(`/messages/lista/${ticketId}`, listMessage);
      }
    } catch (err) {
      if (isMounted.current) {
        toastError(err);
      }
    }
  };

  const handleUploadCopy = async (
    title,
    description,
    buttonText,
    copyText,
    imageBase64,
    ticketId,
  ) => {
    if (!ticketId || isNaN(ticketId)) {
      console.error('ID do Ticket inválido:', ticketId);
      toastError('ID do Ticket inválido.');
      return;
    }

    try {
      const payload = {
        image: imageBase64
          ? imageBase64.replace(/^data:image\/[a-zA-Z]+;base64,/, '')
          : '',
        title: title,
        description: description,
        buttonText: buttonText,
        copyText: copyText,
      };
      if (isMounted.current) {
        await api.post(`/messages/copy/${ticketId}`, payload);
      }
    } catch (err) {
      if (isMounted) {
        toastError(err);
      }
    }
  };

  const handleUploadCALL = async (
    title,
    description,
    buttonText,
    sendCALL,
    imageBase64,
    ticketId,
  ) => {
    if (!ticketId || isNaN(ticketId)) {
      console.error('ID do Ticket inválido:', ticketId);
      toastError('ID do Ticket inválido.');
      return;
    }

    try {
      const payload = {
        image: imageBase64
          ? imageBase64.replace(/^data:image\/[a-zA-Z]+;base64,/, '')
          : '',
        title: title,
        description: description,
        buttonText: buttonText,
        copyText: sendCALL,
      };
      if (isMounted.current) {
        await api.post(`/messages/call/${ticketId}`, payload);
      }
    } catch (err) {
      if (isMounted.current) {
        toastError(err);
      }
    }
  };

  const handleUploadURL = async (
    title,
    description,
    buttonText,
    sendURL,
    imageBase64,
    ticketId,
  ) => {
    if (!ticketId || isNaN(ticketId)) {
      console.error('ID do Ticket inválido:', ticketId);
      toastError('ID do Ticket inválido.');
      return;
    }

    try {
      const payload = {
        image: imageBase64
          ? imageBase64.replace(/^data:image\/[a-zA-Z]+;base64,/, '')
          : '',
        title: title || 'Botão copiar',
        description: description || 'Muito legal esses botões',
        buttonText: buttonText || 'Botão copiar',
        copyText: sendURL || 'Texto padrão para copiar',
      };
      if (isMounted.current) {
        await api.post(`/messages/URL/${ticketId}`, payload);
      }
    } catch (err) {
      if (isMounted.current) {
        toastError(err);
      }
    }
  };

  const handleUploadPIX = async (
    title,
    sendvalue,
    sendkey_type,
    sendmerchant_name,
    sendKey,
    ticketId,
  ) => {
    try {
      if (sendkey_type === 'PHONE' && !sendKey.startsWith('+55')) {
        sendKey = '+55' + sendKey;
      }

      const payload = {
        title: title,
        sendvalue: sendvalue,
        sendkey_type: sendkey_type,
        sendmerchant_name: sendmerchant_name,
        sendKey: sendKey,
      };

      if (isMounted.current) {
        await api.post(`/messages/PIX/${ticketId}`, payload);
      }
    } catch (err) {
      if (isMounted.current) {
        toastError(err);
      }
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageBase64(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const createMessage = async () => {
    try {
      if (selectedOption === 'Lista') {
        await handleUploadListMessage(title, description, inputList, ticketId);
      } else if (selectedOption === 'Copia') {
        await handleUploadCopy(
          title,
          description,
          buttonText,
          copyText,
          imageBase64,
          ticketId,
        );
      } else if (selectedOption === 'Me Ligue') {
        await handleUploadCALL(
          title,
          description,
          buttonText,
          sendCALL,
          imageBase64,
          ticketId,
        );
      } else if (selectedOption === 'URL') {
        await handleUploadURL(
          title,
          description,
          buttonText,
          sendURL,
          imageBase64,
          ticketId,
        );
      } else if (selectedOption === 'PIX') {
        await handleUploadPIX(
          title,
          sendvalue,
          sendkey_type,
          sendmerchant_name,
          sendKey,
          ticketId,
        );
      } else {
        switch (selectedOption) {
          default:
            console.error('Opção não selecionada ou mensagem não gerada.');
            return;
        }
      }
      onClose();
    } catch (error) {
      console.error(error.message);
      toastError('Erro ao processar a mensagem');
    }
  };

  const renderContent = () => {
    switch (selectedOption) {
      case 'Lista':
        return (
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='Título'
                variant='outlined'
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='Descrição'
                variant='outlined'
                multiline
                rows={5}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              {inputList.map((input, index) => (
                <Grid container key={index} spacing={1} alignItems='center'>
                  <Grid size={{ xs: 10 }}>
                    <TextField
                      fullWidth
                      label={`Opção ${index + 1}`}
                      value={input.option}
                      onChange={(e) => handleInputChange(index, e)}
                      variant='outlined'
                      sx={{ marginBottom: '8px' }}
                    />
                  </Grid>
                  <Grid size={{ xs: 2 }}>
                    <Button
                      variant='outlined'
                      onClick={() => handleRemoveOption(index)}
                      sx={theme.custom.cancelButton}
                    >
                      X
                    </Button>
                  </Grid>
                </Grid>
              ))}
              <Button onClick={handleAddOption} sx={theme.custom.confirmButton}>
                Adicionar nova opção
              </Button>
            </Grid>
          </Grid>
        );
      case 'URL':
        return (
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <input
                accept='image/*'
                style={classes.inputFile}
                id='input-file'
                type='file'
                onChange={handleImageChange}
              />
              <label htmlFor='input-file'>
                <Button
                  variant='outlined'
                  component='span'
                  sx={theme.custom.editButton}
                >
                  Imagem
                </Button>
              </label>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='Título'
                variant='outlined'
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='Mensagem'
                variant='outlined'
                multiline
                rows={5}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='Texto do botão'
                variant='outlined'
                value={buttonText}
                onChange={(e) => setButtonText(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='URL'
                variant='outlined'
                value={sendURL}
                onChange={(e) => setSendURL(e.target.value)}
              />
            </Grid>
          </Grid>
        );
      case 'Copia':
        return (
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <input
                accept='image/*'
                style={classes.inputFile}
                id='input-file'
                type='file'
                onChange={handleImageChange}
              />
              <label htmlFor='input-file'>
                {' '}
                <Button
                  variant='outlined'
                  color='primary'
                  component='span'
                  sx={classes.buttonFile}
                >
                  Imagem
                </Button>
              </label>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='Título'
                variant='outlined'
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='Mensagem'
                variant='outlined'
                multiline
                rows={5}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='Texto do botão'
                variant='outlined'
                value={buttonText}
                onChange={(e) => setButtonText(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='Texto para copiar'
                variant='outlined'
                multiline
                rows={4}
                value={copyText}
                onChange={(e) => setCopyText(e.target.value)}
              />
            </Grid>
          </Grid>
        );
      case 'Me Ligue':
        return (
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <input
                accept='image/*'
                style={classes.inputFile}
                id='input-file'
                type='file'
                onChange={handleImageChange}
              />
              <label htmlFor='input-file'>
                <Button
                  variant='outlined'
                  color='primary'
                  component='span'
                  style={classes.buttonFile}
                >
                  Imagem
                </Button>
              </label>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='Título'
                variant='outlined'
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='Mensagem'
                variant='outlined'
                multiline
                rows={5}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='Texto do botão'
                variant='outlined'
                value={buttonText}
                onChange={(e) => setButtonText(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='Telefone'
                variant='outlined'
                defaultValue='5511999999999'
                value={sendCALL}
                onChange={(e) => setSendCall(e.target.value)}
              />
            </Grid>
          </Grid>
        );
      case 'PIX':
        return (
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='Título'
                variant='outlined'
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='Valor'
                variant='outlined'
                value={sendvalue}
                onChange={(e) => setsendvalue(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Select
                fullWidth
                style={classes.formControl}
                value={sendkey_type}
                onChange={(e) => setsendkey_type(e.target.value)}
                displayEmpty
              >
                <MenuItem value='' disabled>
                  Tipo de Chave
                </MenuItem>
                <MenuItem value='CNPJ'>CNPJ</MenuItem>
                <MenuItem value='CPF'>CPF</MenuItem>
                <MenuItem value='PHONE'>Telefone</MenuItem>
                <MenuItem value='EMAIL'>E-mail</MenuItem>
                <MenuItem value='EVP'>Chave Aleatória</MenuItem>
              </Select>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='Nome'
                variant='outlined'
                value={sendmerchant_name}
                onChange={(e) => setsendmerchant_name(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label='Chave PIX'
                variant='outlined'
                value={sendKey}
                onChange={(e) => setsendKey(e.target.value)}
              />
            </Grid>
          </Grid>
        );

      default:
        return null;
    }
  };

  return (
    <Dialog open={modalOpen} onClose={onClose} maxWidth='sm' fullWidth divider>
      <div style={classes.dialogTitleWrapper}>
        <div style={classes.primaryBar}></div>

        {/* Título com posição relativa */}
        <DialogTitle sx={classes.dialogTitle}>Selecione uma opção</DialogTitle>
      </div>

      <DialogContent dividers sx={theme.custom.dialogColor}>
        <Select
          fullWidth
          sx={theme.custom.selectField}
          value={selectedOption}
          onChange={handleSelectChange}
          displayEmpty
          MenuProps={theme.custom.menuProps}
        >
          <MenuItem value='' disabled>
            Selecione
          </MenuItem>
          <MenuItem value='Lista'>Lista</MenuItem>
          <MenuItem value='URL'>URL</MenuItem>
          <MenuItem value='Copia'>Copiar</MenuItem>
          <MenuItem value='Me Ligue'>Me Ligue</MenuItem>
          <MenuItem value='PIX'>PIX</MenuItem>
        </Select>

        {renderContent()}
      </DialogContent>
      <DialogActions
        sx={{
          paddingRight: theme.spacing(2),
          paddingBottom: theme.spacing(2),
          ...theme.custom.dialogColor,
        }}
      >
        <Button
          variant='outlined'
          sx={theme.custom.cancelButton}
          onClick={onClose}
          color='secondary'
        >
          Cancelar
        </Button>
        <Button
          variant='outlined'
          sx={theme.custom.confirmButton}
          onClick={() => createMessage()}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ButtonModal;
